import { render, staticRenderFns } from "./bindProduct.vue?vue&type=template&id=07fe7f33"
import script from "./bindProduct.vue?vue&type=script&lang=js"
export * from "./bindProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports